import AbsenceWithoutLeave from "../Reusable/AbsenceWoutLeaveCard";

export default function AbsentWithoutLeaveSection({
  selectedCompany,
  attendanceData,
  leaveData,
}) {
  return (
    <div className="flex flex-col h-full">
      <div className="bg-white w-full h-full p-4 rounded-md overflow-y-auto">
        <div className="leave__main-section">
          <div className="flex items-center justify-between mt-4">
            <p className="text-xs font-medium text-[var(--color-text-dark)]">
              Absent without Leave
            </p>

            <p className="text-xs font-medium text-[var(--color-text-dark)]">
              Last 30 Days
            </p>
          </div>
        </div>

        <div className="h-full">
          <AbsenceWithoutLeave
            selectedCompany={selectedCompany}
            attendanceData={attendanceData}
            leaveData={leaveData}
          />
        </div>
      </div>
    </div>
  );
}